import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Home from './Home';
import axios from 'axios';
import logo from './logo.svg';
import './App.css';
import Contact from './Contact';
import FloorPlans from './FloorPlans';
import Gallery from './Gallery';
import ForResidents from './ForResidents';
import Navbar3 from './Navbar3';
import Footer2 from './Footer2';
import NewFooter from './NewFooter';
import AmenitiesTwo from './AmenitiesTwo';
import SEOHiddenText from './SEOHiddenText';


class App extends Component {
  constructor(){
    super()
    this.state = {
      homeNav: true,
      response: ''
    }
    this.submitForm = this.submitForm.bind(this)
    this.homeNavTrue = this.homeNavTrue.bind(this)
    this.homeNavFalse = this.homeNavFalse.bind(this)
  }
  componentDidMount() {
    this.callApi()
      .then(res => this.setState({ response: res.express }))
      .catch(err => console.log(err));
  }

  callApi = async () => {
    const response = await fetch('/api/hello');
    const body = await response.json();
    console.log('response status: ', response)

    if (response.status !== 200) throw Error(body.message);
    console.log('response:', response);
    return body;
  };
  
  submitForm() {
    var formObj = {
      "first_name": "ben"
    }
    // maybe undelete this and delete heroku line
    const request = axios.post('http://localhost:3000/contact', formObj);
    // const request = axios.post('https://furn-liv-la-0718.herokuapp.com/contact', formObj);
    
    request.then((result)=>{
      console.log("request = ", );
      //this.setState({modalIsOpen: true, spinnerStatus: 'hideSpinner'});
    }).catch(function (error) {
      console.log("error !!!", error);
    });
  }
  homeNavTrue(){
    this.setState({homeNav: true})
  }
  homeNavFalse(){
    this.setState({homeNav: false})
  }
  render() {
    var bc = 'rgba(0,0,0,0.8)';
    if (this.state.homeNav === true) {bc = 'rgba(0,0,0,0.0)'}
    return (
      <Router>
        <div>
          <SEOHiddenText />
          <Navbar3 changeClass={this.state.homeNav} bc={bc}/>
          <Route exact path ='/' render={() => <Home changeClass={this.homeNavTrue}/>} />
          <Route exact path ='/floor-plans' render={() => <FloorPlans changeClass={this.homeNavFalse}/>} />
          <Route exact path ='/gallery' render={() => <Gallery changeClass={this.homeNavFalse}/>} />
          <Route exact path ='/contact' render={() => <Contact changeClass={this.homeNavFalse}/>} />
          <Route exact path ='/for-residents' render={() => <ForResidents changeClass={this.homeNavFalse}/>} />
          <Route exact path ='/amenities' render={() => <AmenitiesTwo changeClass={this.homeNavFalse}/>} />
          <Footer2 />
        </div>
      </Router>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js